import { Plugin, PluginKey } from 'prosemirror-state'
import { getHash } from 'utils/location'
import { scrollToBlockId } from 'utils/scrollUtils'

const ScrollToHashPluginKey = new PluginKey('ScrollToHash')

export const ScrollToHashOnSyncFinished = new Plugin({
  key: ScrollToHashPluginKey,
  state: {
    init: () => {},
    apply: (tr) => {
      const hash = getHash()
      if (tr.getMeta('initSyncFinished') && hash) {
        scrollToBlockId(hash)
      }
    },
  },
})
